const c = {
  name: "Sonar",
  dimensions: { width: 40, height: 40 },
  content: `
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 40 40" style="enable-background:new 0 0 40 40;" xml:space="preserve">
<style type="text/css">
	.st0{fill: currentColor;}
</style>
<g>
	<g>
		<path class="st0" d="M0,20C0,9,9,0,20,0c5.5,0,10.5,2.2,14.1,5.9l0.7,0.7L24.2,17.2C24.7,18,25,19,25,20c0,2.8-2.2,5-5,5
			c-2.8,0-5-2.2-5-5c0-2.8,2.2-5,5-5c1,0,2,0.3,2.8,0.8l2.1-2.1C23.6,12.6,21.8,12,20,12c-4.4,0-8,3.6-8,8s3.6,8,8,8
			c4.4,0,8-3.6,8-8h2c0,5.5-4.5,10-10,10c-5.5,0-10-4.5-10-10s4.5-10,10-10c2.4,0,4.6,0.8,6.3,2.3l2.1-2.1C26.2,8.2,23.2,7,20,7
			C13.8,7,8.5,11.4,7.3,17.3C8.3,17.8,9,18.8,9,20c0,1.2-0.7,2.2-1.7,2.7c1.1,5,5,8.9,10,10c0.5-1,1.5-1.7,2.7-1.7s2.2,0.7,2.7,1.7
			C28.6,31.5,33,26.2,33,20h2c0,7.3-5.2,13.4-12.1,14.7C22.6,36,21.4,37,20,37c-1.4,0-2.6-1-2.9-2.3c-5.9-1.2-10.6-5.9-11.8-11.8
			C4,22.6,3,21.4,3,20c0-1.4,1-2.6,2.3-2.9C6.6,10.2,12.7,5,20,5c3.8,0,7.2,1.4,9.9,3.7L32,6.6C28.8,3.7,24.6,2,20,2
			C10.1,2,2,10.1,2,20s8.1,18,18,18c4,0,7.7-1.3,10.7-3.5c-0.1-0.3-0.2-0.6-0.2-1c0-1.7,1.3-3,3-3c0.3,0,0.7,0.1,1,0.2
			C36.7,27.7,38,24,38,20h2c0,4.5-1.5,8.6-3.9,11.9c0.3,0.5,0.4,1,0.4,1.6c0,1.7-1.3,3-3,3c-0.6,0-1.1-0.2-1.6-0.4
			C28.6,38.5,24.5,40,20,40C9,40,0,31,0,20z M17,20c0,1.7,1.3,3,3,3c1.7,0,3-1.3,3-3c0-1.7-1.3-3-3-3C18.3,17,17,18.3,17,20z M5,20
			c0,0.6,0.4,1,1,1c0.6,0,1-0.4,1-1c0-0.6-0.4-1-1-1C5.4,19,5,19.4,5,20z M20,33c-0.6,0-1,0.4-1,1s0.4,1,1,1c0.6,0,1-0.4,1-1
			S20.6,33,20,33z M32.5,33.5c0,0.6,0.4,1,1,1c0.6,0,1-0.4,1-1s-0.4-1-1-1C32.9,32.5,32.5,32.9,32.5,33.5z"/>
	</g>
</g>
</svg>
  `
};
export {
  c as Sonar
};
